import React from 'react';
import classNames from 'classnames';

class Marker extends React.PureComponent {
    handleClick = e => {
        if(e){
            //mouse click
            this.props.onClick(e.currentTarget.dataset.id);
        }else {
            //enter key
            this.props.onClick(document.activeElement.dataset.id);
        }

    };

    pressFunction = event => {
        //on enter key
        if(event.keyCode === 13) {
            this.handleClick();
        }
    }
    componentDidMount(){
        document.addEventListener("keydown", this.pressFunction, false);
    }
    componentWillUnmount(){
        document.removeEventListener("keydown", this.pressFunction, false);
    }

    render() {
        const size = 42;
        const markerStyle = {
            position: 'absolute',
            width: size,
            height: size,
            left: -size / 2,
            top: -size / 2
        };

        const { item } = this.props;

        const classes = classNames('Marker', {
            [`Marker--Closed`]: !item.is_open,
        });

        return (
            <div
                className={classes}
                style={markerStyle}
                onClick={this.handleClick}
                data-id={item.identifier}
                id={`id-${item.identifier}`}
                tabIndex="0"
            />
        );
    }
}

Marker.defaultProps = {};

export default Marker;
